/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { BubbleMenu } from '@tiptap/react';
import down from '../../../../../assets/images/icondropdown.svg';

const ProductsBubbleMenu = ({ editor, appendTo }) => {
    const [editAttributes, setEditAttributes] = useState({
        isPopular: false,
        latest: true,
        isHotDeal: false,
        isBuilderChoice: false,
        isProPicks: false,
        isTrendingNow: false,
        mostOrdered: false,
        productCount: 5,
    });

    const [openDropdown, setOpenDropdown] = useState(false);
    const [countError, setCountError] = useState('');

    const dropdownRef = useRef(null);

    const getNodeAttrs = useCallback(() => {
        const nodeAttrs = editor.state.selection.node?.attrs;
        if (nodeAttrs) {
            setEditAttributes({
                isPopular: !!nodeAttrs.isPopular,
                latest: !!nodeAttrs.latest,
                isHotDeal: !!nodeAttrs.isHotDeal,
                isBuilderChoice: !!nodeAttrs.isBuilderChoice,
                isProPicks: !!nodeAttrs.isProPicks,
                isTrendingNow: !!nodeAttrs.isTrendingNow,
                mostOrdered: !!nodeAttrs.mostOrdered,
                productCount: nodeAttrs.productCount || 5,
            });
        }
    }, [editor]);

    const shouldShow = useCallback(() => {
        if (editor.isActive('products')) {
            getNodeAttrs();
        }
        return editor.isActive('products') && editor.isFocused;
    }, [editor]);

    const handleApplyChange = () => {
        editor.chain().focus().updateAttributes('products', editAttributes).run();
    };

    const handleProductTypeChange = (type) => {
        setEditAttributes((prev) => ({
            ...prev,
            isPopular: type === 'isPopular',
            latest: type === 'latest',
            isHotDeal: type === 'isHotDeal',
            isBuilderChoice: type === 'isBuilderChoice',
            isProPicks: type === 'isProPicks',
            isTrendingNow: type === 'isTrendingNow',
            mostOrdered: type === 'mostOrdered',
        }));

        setOpenDropdown(false); // optional: close dropdown after select
    };

    console.log({editAttributes})

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setOpenDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selectedLabel =
        editAttributes.isPopular
            ? 'Popular Product'
            : editAttributes.latest
                ? 'Latest Product'
                : editAttributes.isHotDeal
                    ? 'Hot Deal Product'
                    : editAttributes.isBuilderChoice
                        ? 'Builder’s Choice Product'
                        : editAttributes.isProPicks
                            ? 'Pro Picks Products'
                            : editAttributes.isTrendingNow
                                ? 'Trending Now Products'
                                : editAttributes.mostOrdered
                                    ? 'Most Ordered Products'
                                    : 'Product Type';

    return (
        <BubbleMenu
            editor={editor}
            shouldShow={shouldShow}
            updateDelay={0}
            tippyOptions={{
                zIndex: 99,
                popperOptions: { modifiers: [{ name: 'flip', enabled: false }] },
                appendTo: () => appendTo?.current,
            }}
        >
            <div className="bubble-toggle-menu button-box image-bubble-menu products">
                <div className="products-bubble-block">
                    <div
                        className="dropdown-wrapper order-status-dropdown"
                        ref={dropdownRef}
                    >
                        <div
                            className="dropdown-header"
                            onClick={() => setOpenDropdown(!openDropdown)}
                        >
                            <span className="title">{selectedLabel}</span>
                            <span className={`arrow ${openDropdown ? 'rotate' : ''}`}>
                                <img src={down} alt="arrow" />
                            </span>
                        </div>

                        {openDropdown && (
                            <div className="dropdown-list">
                                <label
                                    className={`dropdown-item ${editAttributes.isPopular ? 'active' : ''}`}
                                    onClick={() => handleProductTypeChange('isPopular')}
                                >
                                    <span>Popular Product</span>
                                </label>

                                <label
                                    className={`dropdown-item ${editAttributes.latest ? 'active' : ''}`}
                                    onClick={() => handleProductTypeChange('latest')}
                                >
                                    <span>Latest Product</span>
                                </label>

                                <label
                                    className={`dropdown-item ${editAttributes.isHotDeal ? 'active' : ''}`}
                                    onClick={() => handleProductTypeChange('isHotDeal')}
                                >
                                    <span>Hot Deal Product</span>
                                </label>
                                <label
                                    className={`dropdown-item ${editAttributes.isBuilderChoice ? 'active' : ''}`}
                                    onClick={() => handleProductTypeChange('isBuilderChoice')}
                                >
                                    <span>Builder’s Choice Product</span>
                                </label>
                                <label
                                    className={`dropdown-item ${editAttributes.isProPicks ? 'active' : ''}`}
                                    onClick={() => handleProductTypeChange('isProPicks')}
                                >
                                    <span>Pro Picks Products</span>
                                </label>
                                <label
                                    className={`dropdown-item ${editAttributes.isTrendingNow ? 'active' : ''}`}
                                    onClick={() => handleProductTypeChange('isTrendingNow')}
                                >
                                    <span>Trending Now Products</span>
                                </label>
                                <label
                                    className={`dropdown-item ${editAttributes.mostOrdered ? 'active' : ''}`}
                                    onClick={() => handleProductTypeChange('mostOrdered')}
                                >
                                    <span>Most Ordered Products</span>
                                </label>
                            </div>
                        )}

                    </div>
                    <label className="text-box">
                        Product Count
                        <input
                            type="text"
                            placeholder="Product Count"
                            value={editAttributes.productCount}
                            onChange={(e) => {
                                const value = e.target.value;

                                // Allow only digits
                                if (!/^\d*$/.test(value)) return;

                                let error = '';
                                if (Number(value) < 0) {
                                    error = 'Minimum product count is 1';
                                }

                                setEditAttributes((prev) => ({
                                    ...prev,
                                    productCount: value,
                                }));

                                setCountError(error);
                            }}
                        />
                    </label>
                    {countError && <div className="error-message">{countError}</div>}
                    <div className="button-element publication-submit-button">
                        <button onClick={handleApplyChange}>Apply</button>
                    </div>
                </div>
            </div>
        </BubbleMenu>
    );
};

export default ProductsBubbleMenu;